import React from "react";

import { Button, Input } from "antd";

import backIcon from "../../../../../assets/images/product/backIconDarkBlue.png";
import { ReactComponent as ArrowRightStepIcon } from "../../../../../assets/images/product/specmanager/arrow-right-s-line.svg";
import { ReactComponent as CheckboxCircleFillIcon } from "../../../../../assets/images/product/specmanager/checkbox-circle-fill.svg";
import { ReactComponent as CircleIcon } from "../../../../../assets/images/product/specmanager/circle-line.svg";
import { ReactComponent as CloseFillIcon } from "../../../../../assets/images/product/specmanager/close-fill.svg";
import searchIcon from "../../../../../assets/images/sample-submission/searchIcon.svg";

export default function EditSpecTestSpecHeader({
  fromModal,
  productTitle,
  testSpecSearchValue,
  onTestSpecSearchValueChange,
  editing,
  previewPrimaryDisabled,
  previewFooterLoading,
  onBackButtonClick,
}) {
  return (
    <div className="EditSpec__TestSpecHeader">
      <div className="EditSpec__TestSpecHeaderLeft">
        <div className="EditSpec__TestSpecHeaderLeftRow">
          {!fromModal && (
            <img
              className="EditSpec__TestSpecHeaderBackIcon"
              src={backIcon}
              alt="back icon"
              onClick={onBackButtonClick}
            />
          )}
          <div
            className="EditSpec__TestSpecHeaderTitle"
            title={productTitle}
          >
            {productTitle}
          </div>
        </div>
      </div>

      <div className="EditSpec__TestSpecHeaderRight">
        <div className="EditSpec__TestSpecSearchAndSteps">
          <div className="EditSpec__TestSpecSearchBox">
            <img className="EditSpec__TestSpecSearchIcon" src={searchIcon} alt="" aria-hidden />
            <Input
              className="EditSpec__TestSpecSearchInput"
              placeholder="Search products..."
              value={testSpecSearchValue || ""}
              onChange={(e) => onTestSpecSearchValueChange?.(e.target.value)}
              aria-label="Search products"
            />
            {(testSpecSearchValue || "").trim() ? (
              <Button
                htmlType="button"
                className="EditSpec__TestSpecSearchClear"
                aria-label="Clear search"
                onClick={() => onTestSpecSearchValueChange("")}
              >
                <CloseFillIcon width={10} height={10} aria-hidden />
              </Button>
            ) : null}
          </div>

          <div
            className={`EditSpec__TestSpecSteps${editing ? " EditSpec__TestSpecSteps--step1-active" : " EditSpec__TestSpecSteps--step2-active"}`}
            role="group"
            aria-label="Test spec steps"
          >
            <Button
              htmlType="button"
              className={`EditSpec__TestSpecStep EditSpec__TestSpecStep--btn${editing ? " EditSpec__TestSpecStep--active" : " EditSpec__TestSpecStep--completed"}`}
              disabled
            >
              <div className="EditSpec__TestSpecStepLabel">
                {editing ? (
                  <CircleIcon className="EditSpec__TestSpecStepIcon" aria-hidden />
                ) : (
                  <CheckboxCircleFillIcon className="EditSpec__TestSpecStepIcon" aria-hidden />
                )}
                Select Products
              </div>
            </Button>
            <ArrowRightStepIcon className="EditSpec__TestSpecStepArrow" aria-hidden />
            {editing ? (
              <span
                className={`EditSpec__TestSpecPreviewStepHost${previewPrimaryDisabled && !previewFooterLoading ? " EditSpec__TestSpecPreviewStepHost--disabledGate" : ""}`}
              >
                <Button
                  htmlType="button"
                  className="EditSpec__TestSpecStep EditSpec__TestSpecStep--btn EditSpec__TestSpecStep--inactive"
                  disabled // always disabled to prevent click, as this is just a visual step indicator (actual preview action is in footer button)
                >
                  <div className="EditSpec__TestSpecStepLabel">
                    <CircleIcon className="EditSpec__TestSpecStepIcon" aria-hidden />
                    Preview Selection
                  </div>
                </Button>
              </span>
            ) : (
              <div
                className="EditSpec__TestSpecStep EditSpec__TestSpecStep--active"
                aria-current="step"
              >
                <div className="EditSpec__TestSpecStepLabel">
                  <CircleIcon className="EditSpec__TestSpecStepIcon" aria-hidden />
                  Preview Selection
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
